module.exports = __webpack_public_path__ + "img/912e7b343ea4872c79e903d6205f9d25.912e7b34.png";